

//HOME PAGE
export const HOME_HELMET_TITLE = "HOME_HELMET_TITLE";
export const HOME_HELMET_DESCRIPTION = "HOME_HELMET_DESCRIPTION";

export const HOME_HEADER_TITLE = "HOME_HEADER_TITLE";
export const HOME_HEADER_SUBTITLE = "HOME_HEADER_SUBTITLE";
export const HOME_RATE_US = "HOME_RATE_US";

// HOME HERO (redesigned)
export const HOME_HERO_EYEBROW = "HOME_HERO_EYEBROW";
export const HOME_HERO_TITLE_LINE1 = "HOME_HERO_TITLE_LINE1";
export const HOME_HERO_TITLE_ACCENT = "HOME_HERO_TITLE_ACCENT";
export const HOME_HERO_TITLE_LINE2 = "HOME_HERO_TITLE_LINE2";
export const HOME_HERO_SUBTITLE = "HOME_HERO_SUBTITLE";
export const HOME_HERO_CTA_PRIMARY = "HOME_HERO_CTA_PRIMARY";
export const HOME_HERO_CTA_SECONDARY = "HOME_HERO_CTA_SECONDARY";
export const HOME_HERO_TRUST_RATING = "HOME_HERO_TRUST_RATING";
export const HOME_HERO_TRUST_BILINGUAL = "HOME_HERO_TRUST_BILINGUAL";
export const HOME_HERO_TRUST_LOCAL = "HOME_HERO_TRUST_LOCAL";
export const HOME_HERO_STAT_YEARS_VALUE = "HOME_HERO_STAT_YEARS_VALUE";
export const HOME_HERO_STAT_YEARS_LABEL = "HOME_HERO_STAT_YEARS_LABEL";
export const HOME_HERO_STAT_FAMILIES_VALUE = "HOME_HERO_STAT_FAMILIES_VALUE";
export const HOME_HERO_STAT_FAMILIES_LABEL = "HOME_HERO_STAT_FAMILIES_LABEL";
export const HOME_HERO_STAT_SERVICES_VALUE = "HOME_HERO_STAT_SERVICES_VALUE";
export const HOME_HERO_STAT_SERVICES_LABEL = "HOME_HERO_STAT_SERVICES_LABEL";
export const HOME_HERO_VIDEO_BADGE = "HOME_HERO_VIDEO_BADGE";

export const HOME_SERVICES_HEADER = "HOME_SERVICES_HEADER";

// HOME SERVICES SECTION (redesigned grid)
export const HOME_SERVICES_EYEBROW = "HOME_SERVICES_EYEBROW";
export const HOME_SERVICES_TITLE = "HOME_SERVICES_TITLE";
export const HOME_SERVICES_SUBTITLE = "HOME_SERVICES_SUBTITLE";
export const HOME_SERVICES_CTA = "HOME_SERVICES_CTA";
export const HOME_SERVICES_LINK_UNEMPLOYMENT = "HOME_SERVICES_LINK_UNEMPLOYMENT";
export const HOME_SERVICES_DESC_UNEMPLOYMENT = "HOME_SERVICES_DESC_UNEMPLOYMENT";
export const HOME_SERVICES_DESC_NOTARY = "HOME_SERVICES_DESC_NOTARY";

// HOME OFFICES / FIND US SECTION
export const OFFICES_EYEBROW = "OFFICES_EYEBROW";
export const OFFICES_TITLE = "OFFICES_TITLE";
export const OFFICES_SUBTITLE = "OFFICES_SUBTITLE";
export const OFFICES_HOURS_TITLE = "OFFICES_HOURS_TITLE";
export const OFFICES_ADDRESS_TITLE = "OFFICES_ADDRESS_TITLE";
export const OFFICES_BTN_DIRECTIONS = "OFFICES_BTN_DIRECTIONS";
export const OFFICES_BTN_CALL = "OFFICES_BTN_CALL";
export const OFFICES_TODAY_BADGE = "OFFICES_TODAY_BADGE";
export const OFFICES_CLOSED_LABEL = "OFFICES_CLOSED_LABEL";
export const OFFICES_STATUS_OPEN_UNTIL = "OFFICES_STATUS_OPEN_UNTIL";
export const OFFICES_STATUS_CLOSING_SOON = "OFFICES_STATUS_CLOSING_SOON";
export const OFFICES_STATUS_CLOSED_TODAY = "OFFICES_STATUS_CLOSED_TODAY";
export const OFFICES_STATUS_OPENS_AT = "OFFICES_STATUS_OPENS_AT";
export const OFFICES_DAY_MON = "OFFICES_DAY_MON";
export const OFFICES_DAY_TUE = "OFFICES_DAY_TUE";
export const OFFICES_DAY_WED = "OFFICES_DAY_WED";
export const OFFICES_DAY_THU = "OFFICES_DAY_THU";
export const OFFICES_DAY_FRI = "OFFICES_DAY_FRI";
export const OFFICES_DAY_SAT = "OFFICES_DAY_SAT";
export const OFFICES_DAY_SUN = "OFFICES_DAY_SUN";

// HOME TESTIMONIALS SECTION (redesigned)
export const HOME_TESTIMONIALS_EYEBROW = "HOME_TESTIMONIALS_EYEBROW";
export const HOME_TESTIMONIALS_TITLE = "HOME_TESTIMONIALS_TITLE";
export const HOME_TESTIMONIALS_SUBTITLE = "HOME_TESTIMONIALS_SUBTITLE";
export const HOME_TESTIMONIALS_RATING_LABEL = "HOME_TESTIMONIALS_RATING_LABEL";
export const HOME_TESTIMONIALS_CTA = "HOME_TESTIMONIALS_CTA";
export const HOME_TESTIMONIALS_T1_QUOTE = "HOME_TESTIMONIALS_T1_QUOTE";
export const HOME_TESTIMONIALS_T1_NAME = "HOME_TESTIMONIALS_T1_NAME";
export const HOME_TESTIMONIALS_T1_ROLE = "HOME_TESTIMONIALS_T1_ROLE";
export const HOME_TESTIMONIALS_T2_QUOTE = "HOME_TESTIMONIALS_T2_QUOTE";
export const HOME_TESTIMONIALS_T2_NAME = "HOME_TESTIMONIALS_T2_NAME";
export const HOME_TESTIMONIALS_T2_ROLE = "HOME_TESTIMONIALS_T2_ROLE";
export const HOME_TESTIMONIALS_T3_QUOTE = "HOME_TESTIMONIALS_T3_QUOTE";
export const HOME_TESTIMONIALS_T3_NAME = "HOME_TESTIMONIALS_T3_NAME";
export const HOME_TESTIMONIALS_T3_ROLE = "HOME_TESTIMONIALS_T3_ROLE";
export const HOME_TESTIMONIALS_T4_QUOTE = "HOME_TESTIMONIALS_T4_QUOTE";
export const HOME_TESTIMONIALS_T4_NAME = "HOME_TESTIMONIALS_T4_NAME";
export const HOME_TESTIMONIALS_T4_ROLE = "HOME_TESTIMONIALS_T4_ROLE";

// HOME PAGE — Intake Forms section
export const HOME_INTAKE_EYEBROW = "HOME_INTAKE_EYEBROW";
export const HOME_INTAKE_TITLE = "HOME_INTAKE_TITLE";
export const HOME_INTAKE_SUBTITLE = "HOME_INTAKE_SUBTITLE";
export const HOME_INTAKE_FORM_TAX = "HOME_INTAKE_FORM_TAX";
export const HOME_INTAKE_FORM_IMM = "HOME_INTAKE_FORM_IMM";
export const HOME_INTAKE_FORM_INS = "HOME_INTAKE_FORM_INS";
export const HOME_INTAKE_FORM_APT = "HOME_INTAKE_FORM_APT";

// SUPPORT PAGE
export const SUPPORT_HELMET_TITLE = "SUPPORT_HELMET_TITLE";
export const SUPPORT_HELMET_DESCRIPTION = "SUPPORT_HELMET_DESCRIPTION";
export const SUPPORT_HERO_EYEBROW = "SUPPORT_HERO_EYEBROW";
export const SUPPORT_HERO_TITLE = "SUPPORT_HERO_TITLE";
export const SUPPORT_HERO_SUBTITLE = "SUPPORT_HERO_SUBTITLE";
export const SUPPORT_HERO_CTA_PRIMARY = "SUPPORT_HERO_CTA_PRIMARY";
export const SUPPORT_HERO_CTA_SECONDARY = "SUPPORT_HERO_CTA_SECONDARY";
export const SUPPORT_HERO_RESPONSE_TIME = "SUPPORT_HERO_RESPONSE_TIME";

// Channels
export const SUPPORT_CHANNELS_EYEBROW = "SUPPORT_CHANNELS_EYEBROW";
export const SUPPORT_CHANNELS_TITLE = "SUPPORT_CHANNELS_TITLE";
export const SUPPORT_CHANNELS_SUBTITLE = "SUPPORT_CHANNELS_SUBTITLE";
export const SUPPORT_CHANNEL_PHONE_TITLE = "SUPPORT_CHANNEL_PHONE_TITLE";
export const SUPPORT_CHANNEL_PHONE_DESC = "SUPPORT_CHANNEL_PHONE_DESC";
export const SUPPORT_CHANNEL_PHONE_CTA = "SUPPORT_CHANNEL_PHONE_CTA";
export const SUPPORT_CHANNEL_WHATSAPP_TITLE = "SUPPORT_CHANNEL_WHATSAPP_TITLE";
export const SUPPORT_CHANNEL_WHATSAPP_DESC = "SUPPORT_CHANNEL_WHATSAPP_DESC";
export const SUPPORT_CHANNEL_WHATSAPP_CTA = "SUPPORT_CHANNEL_WHATSAPP_CTA";
export const SUPPORT_CHANNEL_EMAIL_TITLE = "SUPPORT_CHANNEL_EMAIL_TITLE";
export const SUPPORT_CHANNEL_EMAIL_DESC = "SUPPORT_CHANNEL_EMAIL_DESC";
export const SUPPORT_CHANNEL_EMAIL_CTA = "SUPPORT_CHANNEL_EMAIL_CTA";
export const SUPPORT_CHANNEL_VISIT_TITLE = "SUPPORT_CHANNEL_VISIT_TITLE";
export const SUPPORT_CHANNEL_VISIT_DESC = "SUPPORT_CHANNEL_VISIT_DESC";
export const SUPPORT_CHANNEL_VISIT_CTA = "SUPPORT_CHANNEL_VISIT_CTA";

// Form
export const SUPPORT_FORM_EYEBROW = "SUPPORT_FORM_EYEBROW";
export const SUPPORT_FORM_TITLE = "SUPPORT_FORM_TITLE";
export const SUPPORT_FORM_SUBTITLE = "SUPPORT_FORM_SUBTITLE";
export const SUPPORT_FORM_NAME_LABEL = "SUPPORT_FORM_NAME_LABEL";
export const SUPPORT_FORM_NAME_PLACEHOLDER = "SUPPORT_FORM_NAME_PLACEHOLDER";
export const SUPPORT_FORM_EMAIL_LABEL = "SUPPORT_FORM_EMAIL_LABEL";
export const SUPPORT_FORM_EMAIL_PLACEHOLDER = "SUPPORT_FORM_EMAIL_PLACEHOLDER";
export const SUPPORT_FORM_PHONE_LABEL = "SUPPORT_FORM_PHONE_LABEL";
export const SUPPORT_FORM_PHONE_PLACEHOLDER = "SUPPORT_FORM_PHONE_PLACEHOLDER";
export const SUPPORT_FORM_TOPIC_LABEL = "SUPPORT_FORM_TOPIC_LABEL";
export const SUPPORT_FORM_TOPIC_GENERAL = "SUPPORT_FORM_TOPIC_GENERAL";
export const SUPPORT_FORM_TOPIC_CREDIT = "SUPPORT_FORM_TOPIC_CREDIT";
export const SUPPORT_FORM_TOPIC_TAXES = "SUPPORT_FORM_TOPIC_TAXES";
export const SUPPORT_FORM_TOPIC_IMMIGRATION = "SUPPORT_FORM_TOPIC_IMMIGRATION";
export const SUPPORT_FORM_TOPIC_INSURANCE = "SUPPORT_FORM_TOPIC_INSURANCE";
export const SUPPORT_FORM_TOPIC_TRAVEL = "SUPPORT_FORM_TOPIC_TRAVEL";
export const SUPPORT_FORM_TOPIC_OTHER = "SUPPORT_FORM_TOPIC_OTHER";
export const SUPPORT_FORM_MESSAGE_LABEL = "SUPPORT_FORM_MESSAGE_LABEL";
export const SUPPORT_FORM_MESSAGE_PLACEHOLDER = "SUPPORT_FORM_MESSAGE_PLACEHOLDER";
export const SUPPORT_FORM_CONSENT = "SUPPORT_FORM_CONSENT";
export const SUPPORT_FORM_SUBMIT = "SUPPORT_FORM_SUBMIT";
export const SUPPORT_FORM_REQUIRED = "SUPPORT_FORM_REQUIRED";
export const SUPPORT_FORM_INVALID_EMAIL = "SUPPORT_FORM_INVALID_EMAIL";
export const SUPPORT_FORM_SUCCESS_TITLE = "SUPPORT_FORM_SUCCESS_TITLE";
export const SUPPORT_FORM_SUCCESS_DESC = "SUPPORT_FORM_SUCCESS_DESC";

// FAQ
export const SUPPORT_FAQ_EYEBROW = "SUPPORT_FAQ_EYEBROW";
export const SUPPORT_FAQ_TITLE = "SUPPORT_FAQ_TITLE";
export const SUPPORT_FAQ_SUBTITLE = "SUPPORT_FAQ_SUBTITLE";
export const SUPPORT_FAQ_Q1 = "SUPPORT_FAQ_Q1";
export const SUPPORT_FAQ_A1 = "SUPPORT_FAQ_A1";
export const SUPPORT_FAQ_Q2 = "SUPPORT_FAQ_Q2";
export const SUPPORT_FAQ_A2 = "SUPPORT_FAQ_A2";
export const SUPPORT_FAQ_Q3 = "SUPPORT_FAQ_Q3";
export const SUPPORT_FAQ_A3 = "SUPPORT_FAQ_A3";
export const SUPPORT_FAQ_Q4 = "SUPPORT_FAQ_Q4";
export const SUPPORT_FAQ_A4 = "SUPPORT_FAQ_A4";
export const SUPPORT_FAQ_Q5 = "SUPPORT_FAQ_Q5";
export const SUPPORT_FAQ_A5 = "SUPPORT_FAQ_A5";
export const SUPPORT_FAQ_Q6 = "SUPPORT_FAQ_Q6";
export const SUPPORT_FAQ_A6 = "SUPPORT_FAQ_A6";


export const WELCOME_BUSINESS_HEADER = "WELCOME_BUSINESS_HEADER";
export const WELCOME_BUSINESS_DESCRIPTION = "WELCOME_BUSINESS_DESCRIPTION";
export const DASHBOARD_BUTTON = "DASHBOARD_BUTTON";
export const TEMPLATES_BUTTON = "TEMPLATES_BUTTON";

//HOME PAGE SERVICES 
export const HOME_SERVICES_HEADER_TITLE = "HOME_SERVICES_HEADER_TITLE";


//CONTACT PAGE
export const CONTACT_HELMET_TITLE = "CONTACT_HELMET_TITLE";
export const CONTACT_HELMET_DESCRIPTION = "CONTACT_HELMET_DESCRIPTION";



export const FEATURES_SECTION_HEADER = "FEATURES_SECTION_HEADER"
export const ONLINE_BOOKING_HEADER = "ONLINE_BOOKING_HEADER";
export const ONLINE_BOOKING_DESCRIPTION = "ONLINE_BOOKING_DESCRIPTION"
export const BUSINESS_PROMOTION_HEADER = "BUSINESS_PROMOTION_HEADER"
export const BUSINESS_PROMOTION_DESCRIPTION = "BUSINESS_PROMOTION_DESCRIPTION"
export const ADMIN_DASHBOARD_HEADER = "ADMIN_DASHBOARD_HEADER"
export const ADMIN_DASHBOARD_DESCRIPTION = "ADMIN_DASHBOARD_DESCRIPTION"
export const SMS_EMAIL_NOTIFICATIONS_HEADER = " SMS_EMAIL_NOTIFICATIONS_HEADER"
export const SMS_EMAIL_NOTIFICATIONS_DESCRIPTION = "SMS_EMAIL_NOTIFICATIONS_DESCRIPTION"
export const PAYMENT_HEADER = "PAYMENT_HEADER"
export const PAYMENT_DESCRIPTION = "PAYMENT_DESCRIPTION"
export const WEBSITE_TEMPLATES_HEADER = "WEBSITE_TEMPLATES_HEADER"
export const WEBSITE_TEMPLATES_DESCRIPTION = "WEBSITE_TEMPLATES_DESCRIPTION"
export const ACCESSIBLE_HEADER = "ACCESSIBLE_HEADER"
export const ACCESSIBLE_DESCRIPTION = "ACCESSIBLE_DESCRIPTION"


//LOGIN PAGE
export const LOGIN_FORM_TITLE = "LOGIN_FORM_TITLE"
export const LOGIN_FORM_NOT_REGISTERED_QUESTION = "LOGIN_FORM_NOT_REGISTERED_QUESTION"
export const LOGIN_FORM_NOT_REGISTERED_OPTION = "LOGIN_FORM_NOT_REGISTERED_OPTION"
export const LOGIN_FORM_ISSUES_QUESTION = "LOGIN_FORM_ISSUES_QUESTION"
export const LOGIN_FORM_ISSUES_OPTION = "LOGIN_FORM_ISSUES_OPTION"
export const LOGIN_FORM_REMEBER_ME_LABEL = "LOGIN_FORM_REMEBER_ME_LABEL"

export const LOGIN_FORM_LABEL_EMAIL = "LOGIN_FORM_LABEL_EMAIL"
export const LOGIN_FORM_PLACEHOLDER_EMAIL = "LOGIN_FORM_PLACEHOLDER_EMAIL"

export const LOGIN_FORM_LABEL_PASSWORD = "LOGIN_FORM_LABEL_PASSWORD"
export const LOGIN_FORM_PLACEHOLDER_PASSWORD = "LOGIN_FORM_PLACEHOLDER_PASSWORD"
export const LOGIN_FORM_SUBMIT_BUTTON = "LOGIN_FORM_SUBMIT_BUTTON"
export const LOGIN_FORM_GOOGLE_BUTTON = "LOGIN_FORM_GOOGLE_BUTTON"



//MAIN NAVBAR
export const NAVBAR_LINK_HOME = "NAVBAR_LINK_HOME";
export const NAVBAR_LINK_IMMIGRATION = "NAVBAR_LINK_IMMIGRATION";
export const NAVBAR_LINK_SERVICES = "NAVBAR_LINK_SERVICES";
export const NAVBAR_LINK_INSURANCE = "NAVBAR_LINK_INSURANCE";
export const NAVBAR_LINK_TAXES = "NAVBAR_LINK_TAXES";
export const NAVBAR_LINK_TRAVEL = "NAVBAR_LINK_TRAVEL";
export const NAVBAR_LINK_CREDIT_REPAIR = "NAVBAR_LINK_CREDIT_REPAIR";
export const NAVBAR_LINK_LOGIN = "NAVBAR_LINK_LOGIN";
export const NAVBAR_LINK_SIGNUP = "NAVBAR_LINK_SIGNUP";
export const NAVBAR_LINK_DASHBOARD = "NAVBAR_LINK_DASHBOARD";
export const NAVBAR_LINK_SUPPORT = "NAVBAR_LINK_SUPPORT";
export const NAVBAR_LINK_CONTACT_US = "NAVBAR_LINK_CONTACT_US";
export const NAVBAR_LINK_ABOUT_US = "NAVBAR_LINK_ABOUT_US";
export const NAVBAR_CTA_BOOK_CONSULTATION = "NAVBAR_CTA_BOOK_CONSULTATION";
export const NAVBAR_CTA_CALL_NOW = "NAVBAR_CTA_CALL_NOW";
export const NAVBAR_CTA_WHATSAPP = "NAVBAR_CTA_WHATSAPP";
export const WHATSAPP_FAB_LABEL = "WHATSAPP_FAB_LABEL";
export const WHATSAPP_FAB_TEASER_TITLE = "WHATSAPP_FAB_TEASER_TITLE";
export const WHATSAPP_FAB_TEASER_DESC = "WHATSAPP_FAB_TEASER_DESC";
export const WHATSAPP_DIALOG_CLOSE = "WHATSAPP_DIALOG_CLOSE";
export const WHATSAPP_CHAT_AGENT_NAME = "WHATSAPP_CHAT_AGENT_NAME";
export const WHATSAPP_CHAT_STATUS = "WHATSAPP_CHAT_STATUS";
export const WHATSAPP_CHAT_GREETING = "WHATSAPP_CHAT_GREETING";
export const WHATSAPP_CHAT_PICK_TOPIC = "WHATSAPP_CHAT_PICK_TOPIC";
export const WHATSAPP_CHAT_TOPIC_CREDIT = "WHATSAPP_CHAT_TOPIC_CREDIT";
export const WHATSAPP_CHAT_TOPIC_IMMIGRATION = "WHATSAPP_CHAT_TOPIC_IMMIGRATION";
export const WHATSAPP_CHAT_TOPIC_TAXES = "WHATSAPP_CHAT_TOPIC_TAXES";
export const WHATSAPP_CHAT_TOPIC_INSURANCE = "WHATSAPP_CHAT_TOPIC_INSURANCE";
export const WHATSAPP_CHAT_TOPIC_TRAVEL = "WHATSAPP_CHAT_TOPIC_TRAVEL";
export const WHATSAPP_CHAT_TOPIC_NOTARY = "WHATSAPP_CHAT_TOPIC_NOTARY";
export const WHATSAPP_CHAT_PLACEHOLDER = "WHATSAPP_CHAT_PLACEHOLDER";
export const WHATSAPP_CHAT_SEND = "WHATSAPP_CHAT_SEND";
export const WHATSAPP_CHAT_TYPING = "WHATSAPP_CHAT_TYPING";
export const WHATSAPP_CHAT_DEFAULT_BODY = "WHATSAPP_CHAT_DEFAULT_BODY";
export const WHATSAPP_CHAT_DISCLAIMER = "WHATSAPP_CHAT_DISCLAIMER";
export const COOKIE_CONSENT_MESSAGE = "COOKIE_CONSENT_MESSAGE";
export const COOKIE_CONSENT_ACCEPT = "COOKIE_CONSENT_ACCEPT";
export const COOKIE_CONSENT_DECLINE = "COOKIE_CONSENT_DECLINE";
export const COOKIE_CONSENT_LEARN_MORE = "COOKIE_CONSENT_LEARN_MORE";
export const NAVBAR_TAGLINE = "NAVBAR_TAGLINE";
export const NAVBAR_SERVICES_HEADING = "NAVBAR_SERVICES_HEADING";
export const NAVBAR_SERVICES_SUBHEADING = "NAVBAR_SERVICES_SUBHEADING";
export const NAVBAR_SERVICE_DESC_CREDIT = "NAVBAR_SERVICE_DESC_CREDIT";
export const NAVBAR_SERVICE_DESC_IMMIGRATION = "NAVBAR_SERVICE_DESC_IMMIGRATION";
export const NAVBAR_SERVICE_DESC_TAXES = "NAVBAR_SERVICE_DESC_TAXES";
export const NAVBAR_SERVICE_DESC_INSURANCE = "NAVBAR_SERVICE_DESC_INSURANCE";
export const NAVBAR_SERVICE_DESC_TRAVEL = "NAVBAR_SERVICE_DESC_TRAVEL";
export const NAVBAR_LINK_NOTARY = "NAVBAR_LINK_NOTARY";
export const NAVBAR_SERVICE_DESC_NOTARY = "NAVBAR_SERVICE_DESC_NOTARY";

//MAIN FOOTER
export const MF_PAGE_LINK_TITLE_LINARES = "MF_PAGE_LINK_TITLE_LINARES";
export const MF_PAGE_LINK_TITLE_SERVICES="MF_PAGE_LINK_TITLE_SERVICES";
export const MF_PAGE_LINK_ABOUT_US = "MF_PAGE_LINK_ABOUT_US";
export const MF_PAGE_LINK_TERMS_OF_USE = "MF_PAGE_LINK_TERMS_OF_USE";
export const MF_PAGE_LINK_CONTACT = "MF_PAGE_LINK_CONTACT";
export const MF_PAGE_LINK_PRIVACY_POLICY = "MF_PAGE_LINK_PRIVACY_POLICY";
export const MF_PAGE_LINK_DISCLAIMER = "MF_PAGE_LINK_DISCLAIMER";
export const MF_PAGE_LINK_COOKIES_POLICY = "MF_PAGE_LINK_COOKIES_POLICY";
export const MF_PAGE_LINK_ACCESSIBILITY = "MF_PAGE_LINK_ACCESSIBILITY";
export const FOOTER_BRAND_TAGLINE = "FOOTER_BRAND_TAGLINE";
export const FOOTER_BRAND_BLURB = "FOOTER_BRAND_BLURB";
export const FOOTER_TITLE_COMPANY = "FOOTER_TITLE_COMPANY";
export const FOOTER_TITLE_LEGAL = "FOOTER_TITLE_LEGAL";
export const FOOTER_TITLE_CONTACT = "FOOTER_TITLE_CONTACT";
export const FOOTER_TITLE_FOLLOW = "FOOTER_TITLE_FOLLOW";
export const FOOTER_LINK_SUPPORT = "FOOTER_LINK_SUPPORT";
export const FOOTER_HOURS_LABEL = "FOOTER_HOURS_LABEL";
export const FOOTER_HOURS_WEEKDAYS = "FOOTER_HOURS_WEEKDAYS";
export const FOOTER_HOURS_SATURDAY = "FOOTER_HOURS_SATURDAY";
export const FOOTER_HOURS_SUNDAY = "FOOTER_HOURS_SUNDAY";
export const FOOTER_RIGHTS_RESERVED = "FOOTER_RIGHTS_RESERVED";
export const FOOTER_MADE_WITH = "FOOTER_MADE_WITH";



//UNEMPLOYMENT PAGE
export const UNEMPLOYMENT_HELMET_TITLE = "UNEMPLOYMENT_HELMET_TITLE"
export const UNEMPLOYMENT_HELMET_DESCRIPTION = "UNEMPLOYMENT_HELMET_DESCRIPTION"



//CREDIT REAPAIR PAGE
export const UNEMPLOYMENT_PRICING_PLAN_TITLE = "UNEMPLOYMENT_PRICING_PLAN_TITLE"
export const UNEMPLOYMENT_PRICING_PLAN_SUBTITLE = "UNEMPLOYMENT_PRICING_PLAN_SUBTITLE"
export const UNEMPLOYMENT_HEADER_TITLE = "UNEMPLOYMENT_HEADER_TITLE"
export const UNEMPLOYMENT_HEADER_DESCRIPTION = "UNEMPLOYMENT_HEADER_DESCRIPTION"
export const UNEMPLOYMENT_PRICING_TITLE = "UNEMPLOYMENT_PRICING_TITLE"
export const UNEMPLOYMENT_PRICING_DESCRIPTION = "UNEMPLOYMENT_PRICING_DESCRIPTION"
export const UNEMPLOYMENT_PRICING_TRIAL_DESCRIPTION = "UNEMPLOYMENT_PRICING_TRIAL_DESCRIPTION"
export const UNEMPLOYMENT_PRICING_TESTIMONIAL = "UNEMPLOYMENT_PRICING_TESTIMONIAL"
export const UNEMPLOYMENT_PRICING_PRO_LATE_PAYMENTS = "UNEMPLOYMENT_PRICING_PRO_LATE_PAYMENTS"
export const UNEMPLOYMENT_PRICING_PRO_HARD_INQUIRIES = "UNEMPLOYMENT_PRICING_PRO_HARD_INQUIRIES"
export const UNEMPLOYMENT_PRICING_PRO_PERSONAL_INFORMATION = "UNEMPLOYMENT_PRICING_PRO_PERSONAL_INFORMATION"
export const UNEMPLOYMENT_PRICING_PRO_COLLECTION_CHARGES = "UNEMPLOYMENT_PRICING_PRO_COLLECTION_CHARGES"
export const UNEMPLOYMENT_PRICING_PRO_CHARGE_OFFS = "UNEMPLOYMENT_PRICING_PRO_CHARGE_OFFS"
export const UNEMPLOYMENT_PRICING_PRO_MEDICAL_BILLS = "UNEMPLOYMENT_PRICING_PRO_MEDICAL_BILLS"
export const UNEMPLOYMENT_PRICING_PRO_STUDENT_LOANS = "UNEMPLOYMENT_PRICING_PRO_STUDENT_LOANS"
export const UNEMPLOYMENT_PRICING_PRO_REPOSSESSIONS = "UNEMPLOYMENT_PRICING_PRO_REPOSSESSIONS"
export const UNEMPLOYMENT_PRICING_PRO_BANKRUPTICIES = "UNEMPLOYMENT_PRICING_PRO_BANKRUPTICIES"
export const UNEMPLOYMENT_PRICING_PRO_PUBLIC_RECORDS = "UNEMPLOYMENT_PRICING_PRO_PUBLIC_RECORDS"
export const UNEMPLOYMENT_PRICING_FREE_CONSULTING = "UNEMPLOYMENT_PRICING_FREE_CONSULTING"
export const UNEMPLOYMENT_PRICING_FREE_CONSULTING_DESCRIPTION = "UNEMPLOYMENT_PRICING_FREE_CONSULTING_DESCRIPTION"
export const UNEMPLOYMENT_PRICING_PRO_BUTTON_SUBSCRIBE = "UNEMPLOYMENT_PRICING_PRO_BUTTON_SUBSCRIBE"
export const UNEMPLOYMENT_PRICING_FREE_CONSULTING_BUTTON_CONTACT = "UNEMPLOYMENT_PRICING_FREE_CONSULTING_BUTTON_CONTACT"


//CREDIT REPAIR MANAGE SUBSCRIPTION
export const UNEMPLOYMENT_MANAGE_SUBSCRIPTION_TITLE = "UNEMPLOYMENT_MANAGE_SUBSCRIPTION_TITLE"
export const UNEMPLOYMENT_MANAGE_SUBSCRIPTION_INSTRUCTION = "UNEMPLOYMENT_MANAGE_SUBSCRIPTION_DESCRIPTION"
export const UNEMPLOYMENT_MANAGE_SUBSCRIPTION_BUTTON = "UNEMPLOYMENT_MANAGE_SUBSCRIPTION_BUTTON"
//CREDIT REAPAIR PROCESS
export const UNEMPLOYMENT_PROCESS_HEADER = "UNEMPLOYMENT_PROCESS_HEADER"
export const UNEMPLOYMENT_PROCESS_SIGUNP_HEADER = "UNEMPLOYMENT_PROCESS_SIGUNP_HEADER"
export const UNEMPLOYMENT_PROCESS_SIGUNP_DESCRIPTION = "UNEMPLOYMENT_PROCESS_SIGUNP_DESCRIPTION"
export const UNEMPLOYMENT_PROCESS_COACH_HEADER = "UNEMPLOYMENT_PROCESS_COACH_HEADER"
export const UNEMPLOYMENT_PROCESS_COACH_DESCRIPTION = "UNEMPLOYMENT_PROCESS_COACH_DESCRIPTION"
export const UNEMPLOYMENT_PROCESS_ASSESTMENT_HEADER = "UNEMPLOYMENT_PROCESS_ASSESTMENT_HEADER"
export const UNEMPLOYMENT_PROCESS_ASSESTMENT_DESCRIPTION = "UNEMPLOYMENT_PROCESS_ASSESTMENT_DESCRIPTION"
export const UNEMPLOYMENT_PROCESS_DISPUTES_HEADER = "UNEMPLOYMENT_PROCESS_DISPUTES_HEADER"
export const UNEMPLOYMENT_PROCESS_DISPUTES_DESCRIPTION = "UNEMPLOYMENT_PROCESS_DISPUTES_DESCRIPTION"

//CREDIT REAPAIR CONTACT NOTIFICATION
export const UNEMPLOYMENT_CONTACT_NOTIFICATION_HEADER = "UNEMPLOYMENT_CONTACT_NOTIFICATION_HEADER"
export const UNEMPLOYMENT_CONTACT_NOTIFICATION_DESCRIPTION = "UNEMPLOYMENT_CONTACT_NOTIFICATION_DESCRIPTION"

//CREDIT REAPAIR FAQ
export const UNEMPLOYMENT_FAQ_TITLE = "UNEMPLOYMENT_FAQ_TITLE"
export const UNEMPLOYMENT_FAQ_SUBTITLE = "UNEMPLOYMENT_FAQ_SUBTITLE"
export const UNEMPLOYMENT_FAQ_DESCRIPTION = "UNEMPLOYMENT_FAQ_DESCRIPTION"
export const UNEMPLOYMENT_FAQ_HOW_WORK_QUESTION = "UNEMPLOYMENT_FAQ_HOW_WORK_QUESTION"
export const UNEMPLOYMENT_FAQ_HOW_WORK_ANSWER = "UNEMPLOYMENT_FAQ_HOW_WORK_ANSWER"
export const UNEMPLOYMENT_FAQ_HOW_LONG_TAKE_QUESTION = "UNEMPLOYMENT_FAQ_HOW_LONG_TAKE_QUESTION"
export const UNEMPLOYMENT_FAQ_HOW_LONG_TAKE_ANSWER = "UNEMPLOYMENT_FAQ_HOW_LONG_TAKE_ANSWER"
export const UNEMPLOYMENT_FAQ_CAN_I_DO_IT_QUESTION = "UNEMPLOYMENT_FAQ_CAN_I_DO_IT_QUESTION"
export const UNEMPLOYMENT_FAQ_CAN_I_DO_IT_ANSWER = "UNEMPLOYMENT_FAQ_CAN_I_DO_IT_ANSWER"
export const UNEMPLOYMENT_FAQ_CAN_LINARES_GUARANTEE_RESULTS_QUESTION = "UNEMPLOYMENT_FAQ_CAN_LINARES_GUARANTEE_RESULTS_QUESTION"
export const UNEMPLOYMENT_FAQ_CAN_LINARES_GUARANTEE_RESULTS_ANSWER = "UNEMPLOYMENT_FAQ_CAN_LINARES_GUARANTEE_RESULTS_ANSWER"
export const UNEMPLOYMENT_FAQ_WHY_CREDIT_ITS_IMPORTANT_QUESTION = "UNEMPLOYMENT_FAQ_WHY_CREDIT_ITS_IMPORTANT_QUESTION"
export const UNEMPLOYMENT_FAQ_WHY_CREDIT_ITS_IMPORTANT_ANSWER = "UNEMPLOYMENT_FAQ_WHY_CREDIT_ITS_IMPORTANT_ANSWER"
export const UNEMPLOYMENT_FAQ_WILL_DISPUTING_ERRORS_HURT_CREDIT_SCORE_QUESTION = "UNEMPLOYMENT_FAQ_WILL_DISPUTING_ERRORS_HURT_CREDIT_SCORE_QUESTION"
export const UNEMPLOYMENT_FAQ_WILL_DISPUTING_ERRORS_HURT_CREDIT_SCORE_ANSWER = "UNEMPLOYMENT_FAQ_WILL_DISPUTING_ERRORS_HURT_CREDIT_SCORE_ANSWER"
export const UNEMPLOYMENT_FAQ_WHAT_IS_GOOD_CREDIT_SCORE_QUESTION = "UNEMPLOYMENT_FAQ_WHAT_IS_GOOD_CREDIT_SCORE_QUESTION"
export const UNEMPLOYMENT_FAQ_WHAT_IS_GOOD_CREDIT_SCORE_ANSWER = "UNEMPLOYMENT_FAQ_WHAT_IS_GOOD_CREDIT_SCORE_ANSWER"





// CREDIT REAPAIR PAGE HELMET
export const CR_HELMET_TITLE = "CR_HELMET_TITLE"
export const CR_HELMET_DESCRIPTION = "CR_HELMET_DESCRIPTION"







//CREDIT REAPAIR PAGE
export const CR_PRICING_PLAN_TITLE = "CR_PRICING_PLAN_TITLE"
export const CR_PRICING_PLAN_SUBTITLE = "CR_PRICING_PLAN_SUBTITLE"
export const CR_HEADER_TITLE = "CR_HEADER_TITLE"
export const CR_HEADER_DESCRIPTION = "CR_HEADER_DESCRIPTION"
export const CR_HERO_CTA_PLANS = "CR_HERO_CTA_PLANS"
export const CR_HERO_CTA_CALL = "CR_HERO_CTA_CALL"
export const CR_HERO_TRUST_FAMILIES = "CR_HERO_TRUST_FAMILIES"
export const CR_HERO_TRUST_BUREAUS = "CR_HERO_TRUST_BUREAUS"
export const CR_HERO_TRUST_BILINGUAL = "CR_HERO_TRUST_BILINGUAL"
export const CR_PRICING_EYEBROW = "CR_PRICING_EYEBROW"
export const CR_PRICING_FREE_PRICE_LABEL = "CR_PRICING_FREE_PRICE_LABEL"
export const CR_PRICING_PRO_LABEL = "CR_PRICING_PRO_LABEL"
export const CR_PRICING_PRO_BADGE = "CR_PRICING_PRO_BADGE"
export const CR_PRICING_PRO_PRICE_LABEL = "CR_PRICING_PRO_PRICE_LABEL"
export const CR_PROCESS_EYEBROW = "CR_PROCESS_EYEBROW"
export const CR_TESTIMONIAL_EYEBROW = "CR_TESTIMONIAL_EYEBROW"
export const CR_TESTIMONIAL_TITLE = "CR_TESTIMONIAL_TITLE"
export const CR_FAQ_CTA_TITLE = "CR_FAQ_CTA_TITLE"
export const CR_FAQ_CTA_SUBTITLE = "CR_FAQ_CTA_SUBTITLE"
export const CR_PRICING_TITLE = "CR_PRICING_TITLE"
export const CR_PRICING_DESCRIPTION = "CR_PRICING_DESCRIPTION"
export const CR_PRICING_TRIAL_DESCRIPTION = "CR_PRICING_TRIAL_DESCRIPTION"
export const CR_PRICING_TESTIMONIAL = "CR_PRICING_TESTIMONIAL"
export const CR_PRICING_PRO_LATE_PAYMENTS = "CR_PRICING_PRO_LATE_PAYMENTS"
export const CR_PRICING_PRO_HARD_INQUIRIES = "CR_PRICING_PRO_HARD_INQUIRIES"
export const CR_PRICING_PRO_PERSONAL_INFORMATION = "CR_PRICING_PRO_PERSONAL_INFORMATION"
export const CR_PRICING_PRO_COLLECTION_CHARGES = "CR_PRICING_PRO_COLLECTION_CHARGES"
export const CR_PRICING_PRO_CHARGE_OFFS = "CR_PRICING_PRO_CHARGE_OFFS"
export const CR_PRICING_PRO_MEDICAL_BILLS = "CR_PRICING_PRO_MEDICAL_BILLS"
export const CR_PRICING_PRO_STUDENT_LOANS = "CR_PRICING_PRO_STUDENT_LOANS"
export const CR_PRICING_PRO_REPOSSESSIONS = "CR_PRICING_PRO_REPOSSESSIONS"
export const CR_PRICING_PRO_BANKRUPTICIES = "CR_PRICING_PRO_BANKRUPTICIES"
export const CR_PRICING_PRO_PUBLIC_RECORDS = "CR_PRICING_PRO_PUBLIC_RECORDS"
export const CR_PRICING_FREE_CONSULTING = "CR_PRICING_FREE_CONSULTING"
export const CR_PRICING_FREE_CONSULTING_DESCRIPTION = "CR_PRICING_FREE_CONSULTING_DESCRIPTION"
export const CR_PRICING_PRO_BUTTON_SUBSCRIBE = "CR_PRICING_PRO_BUTTON_SUBSCRIBE"
export const CR_PRICING_FREE_CONSULTING_BUTTON_CONTACT = "CR_PRICING_FREE_CONSULTING_BUTTON_CONTACT"


//CREDIT REPAIR MANAGE SUBSCRIPTION
export const CR_MANAGE_SUBSCRIPTION_TITLE = "CR_MANAGE_SUBSCRIPTION_TITLE"
export const CR_MANAGE_SUBSCRIPTION_INSTRUCTION = "CR_MANAGE_SUBSCRIPTION_DESCRIPTION"
export const CR_MANAGE_SUBSCRIPTION_BUTTON = "CR_MANAGE_SUBSCRIPTION_BUTTON"
//CREDIT REAPAIR PROCESS
export const CR_PROCESS_HEADER = "CR_PROCESS_HEADER"
export const CR_PROCESS_SIGUNP_HEADER = "CR_PROCESS_SIGUNP_HEADER"
export const CR_PROCESS_SIGUNP_DESCRIPTION = "CR_PROCESS_SIGUNP_DESCRIPTION"
export const CR_PROCESS_COACH_HEADER = "CR_PROCESS_COACH_HEADER"
export const CR_PROCESS_COACH_DESCRIPTION = "CR_PROCESS_COACH_DESCRIPTION"
export const CR_PROCESS_ASSESTMENT_HEADER = "CR_PROCESS_ASSESTMENT_HEADER"
export const CR_PROCESS_ASSESTMENT_DESCRIPTION = "CR_PROCESS_ASSESTMENT_DESCRIPTION"
export const CR_PROCESS_DISPUTES_HEADER = "CR_PROCESS_DISPUTES_HEADER"
export const CR_PROCESS_DISPUTES_DESCRIPTION = "CR_PROCESS_DISPUTES_DESCRIPTION"

//CREDIT REAPAIR CONTACT NOTIFICATION
export const CR_CONTACT_NOTIFICATION_HEADER = "CR_CONTACT_NOTIFICATION_HEADER"
export const CR_CONTACT_NOTIFICATION_DESCRIPTION = "CR_CONTACT_NOTIFICATION_DESCRIPTION"

//CREDIT REAPAIR FREE SCORE by MyFreeScoreNow
export const CR_FREE_SCORE_TITLE = "CR_FREE_SCORE_TITLE"
export const CR_FREE_SCORE_DESCRIPTION = "CR_FREE_SCORE_DESCRIPTION"

export const CR_FREE_SCORE_MFSN_BUTTON = "CR_FREE_SCORE_MFSN_BUTTON"
export const CR_FREE_SCORE_SQUARE_BUTTON = "CR_FREE_SCORE_SQUARE_BUTTON"

export const CR_FREE_SCORE_BUTTON_SUBSCRIPTION = "CR_FREE_SCORE_BUTTON_SUBSCRIPTION"
export const CR_FREE_SCORE_DISCLAIMER = "CR_FREE_SCORE_DISCLAIMER"
export const CR_FREE_SCORE_REDIRECT_NOTIFICATION = "CR_FREE_SCORE_REDIRECT_NOTIFICATION"
export const CR_FREE_SCORE_MFSN_REDIRECT_ALERT_DESCRIPTION = "CR_FREE_SCORE_MFSN_REDIRECT_ALERT_DESCRIPTION"

export const CR_FREE_SCORE_SQUARE_REDIRECT_NOTIFICATION = "CR_FREE_SCORE_SQUARE_REDIRECT_NOTIFICATION"
export const CR_FREE_SCORE_SQUARE_REDIRECT_ALERT_DESCRIPTION = "CR_FREE_SCORE_SQUARE_REDIRECT_ALERT_DESCRIPTION"

export const CR_FREE_SCORE_REDIRECT_ALERT_BUTTON = "CR_FREE_SCORE_REDIRECT_ALERT_BUTTON"
export const CR_FREE_SCORE_REDIRECT_ALERT_CANCEL_BUTTON = "CR_FREE_SCORE_REDIRECT_ALERT_CANCEL_BUTTON"
export const CR_FREE_SCORE_EYEBROW = "CR_FREE_SCORE_EYEBROW"
export const CR_FREE_SCORE_PRICE_LABEL = "CR_FREE_SCORE_PRICE_LABEL"
export const CR_FREE_SCORE_MFSN_TAGLINE = "CR_FREE_SCORE_MFSN_TAGLINE"
export const CR_FREE_SCORE_SQUARE_TAGLINE = "CR_FREE_SCORE_SQUARE_TAGLINE"
export const CR_FREE_SCORE_RECOMMENDED = "CR_FREE_SCORE_RECOMMENDED"
export const CR_FREE_SCORE_FEATURE_3_BUREAUS = "CR_FREE_SCORE_FEATURE_3_BUREAUS"
export const CR_FREE_SCORE_FEATURE_MONITORING = "CR_FREE_SCORE_FEATURE_MONITORING"
export const CR_FREE_SCORE_FEATURE_ALERTS = "CR_FREE_SCORE_FEATURE_ALERTS"
export const CR_FREE_SCORE_FEATURE_CONSULTING = "CR_FREE_SCORE_FEATURE_CONSULTING"
export const CR_FREE_SCORE_FEATURE_DISPUTES = "CR_FREE_SCORE_FEATURE_DISPUTES"


// IMMIGRATION PAGE
export const IMM_HELMET_TITLE = "IMM_HELMET_TITLE"
export const IMM_HELMET_DESCRIPTION = "IMM_HELMET_DESCRIPTION"

export const IMM_HERO_EYEBROW = "IMM_HERO_EYEBROW"
export const IMM_HERO_TITLE = "IMM_HERO_TITLE"
export const IMM_HERO_TITLE_ACCENT = "IMM_HERO_TITLE_ACCENT"
export const IMM_HERO_SUBTITLE = "IMM_HERO_SUBTITLE"
export const IMM_HERO_CTA_CONSULT = "IMM_HERO_CTA_CONSULT"
export const IMM_HERO_CTA_CALL = "IMM_HERO_CTA_CALL"
export const IMM_HERO_TRUST_YEARS = "IMM_HERO_TRUST_YEARS"
export const IMM_HERO_TRUST_FAMILIES = "IMM_HERO_TRUST_FAMILIES"
export const IMM_HERO_TRUST_BILINGUAL = "IMM_HERO_TRUST_BILINGUAL"

export const IMM_SERVICES_EYEBROW = "IMM_SERVICES_EYEBROW"
export const IMM_SERVICES_TITLE = "IMM_SERVICES_TITLE"
export const IMM_SERVICES_SUBTITLE = "IMM_SERVICES_SUBTITLE"
export const IMM_SERVICE_GREENCARD_TITLE = "IMM_SERVICE_GREENCARD_TITLE"
export const IMM_SERVICE_GREENCARD_DESC = "IMM_SERVICE_GREENCARD_DESC"
export const IMM_SERVICE_FAMILY_TITLE = "IMM_SERVICE_FAMILY_TITLE"
export const IMM_SERVICE_FAMILY_DESC = "IMM_SERVICE_FAMILY_DESC"
export const IMM_SERVICE_WORK_TITLE = "IMM_SERVICE_WORK_TITLE"
export const IMM_SERVICE_WORK_DESC = "IMM_SERVICE_WORK_DESC"
export const IMM_SERVICE_CITIZENSHIP_TITLE = "IMM_SERVICE_CITIZENSHIP_TITLE"
export const IMM_SERVICE_CITIZENSHIP_DESC = "IMM_SERVICE_CITIZENSHIP_DESC"
export const IMM_SERVICE_DACA_TITLE = "IMM_SERVICE_DACA_TITLE"
export const IMM_SERVICE_DACA_DESC = "IMM_SERVICE_DACA_DESC"
export const IMM_SERVICE_ASYLUM_TITLE = "IMM_SERVICE_ASYLUM_TITLE"
export const IMM_SERVICE_ASYLUM_DESC = "IMM_SERVICE_ASYLUM_DESC"

export const IMM_PROCESS_EYEBROW = "IMM_PROCESS_EYEBROW"
export const IMM_PROCESS_TITLE = "IMM_PROCESS_TITLE"
export const IMM_PROCESS_STEP1_TITLE = "IMM_PROCESS_STEP1_TITLE"
export const IMM_PROCESS_STEP1_DESC = "IMM_PROCESS_STEP1_DESC"
export const IMM_PROCESS_STEP2_TITLE = "IMM_PROCESS_STEP2_TITLE"
export const IMM_PROCESS_STEP2_DESC = "IMM_PROCESS_STEP2_DESC"
export const IMM_PROCESS_STEP3_TITLE = "IMM_PROCESS_STEP3_TITLE"
export const IMM_PROCESS_STEP3_DESC = "IMM_PROCESS_STEP3_DESC"
export const IMM_PROCESS_STEP4_TITLE = "IMM_PROCESS_STEP4_TITLE"
export const IMM_PROCESS_STEP4_DESC = "IMM_PROCESS_STEP4_DESC"

export const IMM_WHY_EYEBROW = "IMM_WHY_EYEBROW"
export const IMM_WHY_TITLE = "IMM_WHY_TITLE"
export const IMM_WHY_SUBTITLE = "IMM_WHY_SUBTITLE"
export const IMM_WHY_ITEM1_TITLE = "IMM_WHY_ITEM1_TITLE"
export const IMM_WHY_ITEM1_DESC = "IMM_WHY_ITEM1_DESC"
export const IMM_WHY_ITEM2_TITLE = "IMM_WHY_ITEM2_TITLE"
export const IMM_WHY_ITEM2_DESC = "IMM_WHY_ITEM2_DESC"
export const IMM_WHY_ITEM3_TITLE = "IMM_WHY_ITEM3_TITLE"
export const IMM_WHY_ITEM3_DESC = "IMM_WHY_ITEM3_DESC"
export const IMM_WHY_ITEM4_TITLE = "IMM_WHY_ITEM4_TITLE"
export const IMM_WHY_ITEM4_DESC = "IMM_WHY_ITEM4_DESC"

export const IMM_FAQ_EYEBROW = "IMM_FAQ_EYEBROW"
export const IMM_FAQ_TITLE = "IMM_FAQ_TITLE"
export const IMM_FAQ_SUBTITLE = "IMM_FAQ_SUBTITLE"
export const IMM_FAQ_Q1 = "IMM_FAQ_Q1"
export const IMM_FAQ_A1 = "IMM_FAQ_A1"
export const IMM_FAQ_Q2 = "IMM_FAQ_Q2"
export const IMM_FAQ_A2 = "IMM_FAQ_A2"
export const IMM_FAQ_Q3 = "IMM_FAQ_Q3"
export const IMM_FAQ_A3 = "IMM_FAQ_A3"
export const IMM_FAQ_Q4 = "IMM_FAQ_Q4"
export const IMM_FAQ_A4 = "IMM_FAQ_A4"
export const IMM_FAQ_Q5 = "IMM_FAQ_Q5"
export const IMM_FAQ_A5 = "IMM_FAQ_A5"

export const IMM_CTA_TITLE = "IMM_CTA_TITLE"
export const IMM_CTA_SUBTITLE = "IMM_CTA_SUBTITLE"
export const IMM_CTA_BUTTON = "IMM_CTA_BUTTON"

export const IMM_DISCLAIMER_EYEBROW = "IMM_DISCLAIMER_EYEBROW"
export const IMM_DISCLAIMER_TITLE = "IMM_DISCLAIMER_TITLE"
export const IMM_DISCLAIMER_BODY = "IMM_DISCLAIMER_BODY"

// IMMIGRATION PAGE — E&W Partner Banner
export const IMM_PARTNER_EYEBROW = "IMM_PARTNER_EYEBROW"
export const IMM_PARTNER_TITLE = "IMM_PARTNER_TITLE"
export const IMM_PARTNER_SUBTITLE = "IMM_PARTNER_SUBTITLE"
export const IMM_PARTNER_TAGLINE = "IMM_PARTNER_TAGLINE"
export const IMM_PARTNER_TRUST1 = "IMM_PARTNER_TRUST1"
export const IMM_PARTNER_TRUST2 = "IMM_PARTNER_TRUST2"
export const IMM_PARTNER_TRUST3 = "IMM_PARTNER_TRUST3"
export const IMM_PARTNER_INCLUDES = "IMM_PARTNER_INCLUDES"
export const IMM_SERVICE_RENEWALS_TITLE = "IMM_SERVICE_RENEWALS_TITLE"
export const IMM_SERVICE_RENEWALS_DESC = "IMM_SERVICE_RENEWALS_DESC"


// TAXES PAGE  (We are NOT a CPA firm — notary + document assistance only.)
export const TAX_HELMET_TITLE = "TAX_HELMET_TITLE"
export const TAX_HELMET_DESCRIPTION = "TAX_HELMET_DESCRIPTION"

export const TAX_HERO_EYEBROW = "TAX_HERO_EYEBROW"
export const TAX_HERO_TITLE = "TAX_HERO_TITLE"
export const TAX_HERO_TITLE_ACCENT = "TAX_HERO_TITLE_ACCENT"
export const TAX_HERO_SUBTITLE = "TAX_HERO_SUBTITLE"
export const TAX_HERO_CTA_BOOK = "TAX_HERO_CTA_BOOK"
export const TAX_HERO_CTA_CALL = "TAX_HERO_CTA_CALL"
export const TAX_HERO_TRUST_NOTARY = "TAX_HERO_TRUST_NOTARY"
export const TAX_HERO_TRUST_BILINGUAL = "TAX_HERO_TRUST_BILINGUAL"
export const TAX_HERO_TRUST_PARTNERS = "TAX_HERO_TRUST_PARTNERS"

export const TAX_DISCLAIMER_EYEBROW = "TAX_DISCLAIMER_EYEBROW"
export const TAX_DISCLAIMER_TITLE = "TAX_DISCLAIMER_TITLE"
export const TAX_DISCLAIMER_BODY = "TAX_DISCLAIMER_BODY"
export const TAX_DISCLAIMER_DO_LABEL = "TAX_DISCLAIMER_DO_LABEL"
export const TAX_DISCLAIMER_DO_1 = "TAX_DISCLAIMER_DO_1"
export const TAX_DISCLAIMER_DO_2 = "TAX_DISCLAIMER_DO_2"
export const TAX_DISCLAIMER_DO_3 = "TAX_DISCLAIMER_DO_3"
export const TAX_DISCLAIMER_DO_4 = "TAX_DISCLAIMER_DO_4"
export const TAX_DISCLAIMER_DONT_LABEL = "TAX_DISCLAIMER_DONT_LABEL"
export const TAX_DISCLAIMER_DONT_1 = "TAX_DISCLAIMER_DONT_1"
export const TAX_DISCLAIMER_DONT_2 = "TAX_DISCLAIMER_DONT_2"
export const TAX_DISCLAIMER_DONT_3 = "TAX_DISCLAIMER_DONT_3"

export const TAX_SERVICES_EYEBROW = "TAX_SERVICES_EYEBROW"
export const TAX_SERVICES_TITLE = "TAX_SERVICES_TITLE"
export const TAX_SERVICES_SUBTITLE = "TAX_SERVICES_SUBTITLE"
export const TAX_SERVICE_ITIN_TITLE = "TAX_SERVICE_ITIN_TITLE"
export const TAX_SERVICE_ITIN_DESC = "TAX_SERVICE_ITIN_DESC"
export const TAX_SERVICE_DOCS_TITLE = "TAX_SERVICE_DOCS_TITLE"
export const TAX_SERVICE_DOCS_DESC = "TAX_SERVICE_DOCS_DESC"
export const TAX_SERVICE_TRANSLATE_TITLE = "TAX_SERVICE_TRANSLATE_TITLE"
export const TAX_SERVICE_TRANSLATE_DESC = "TAX_SERVICE_TRANSLATE_DESC"
export const TAX_SERVICE_NOTARY_TITLE = "TAX_SERVICE_NOTARY_TITLE"
export const TAX_SERVICE_NOTARY_DESC = "TAX_SERVICE_NOTARY_DESC"
export const TAX_SERVICE_REFERRAL_TITLE = "TAX_SERVICE_REFERRAL_TITLE"
export const TAX_SERVICE_REFERRAL_DESC = "TAX_SERVICE_REFERRAL_DESC"
export const TAX_SERVICE_FOLLOWUP_TITLE = "TAX_SERVICE_FOLLOWUP_TITLE"
export const TAX_SERVICE_FOLLOWUP_DESC = "TAX_SERVICE_FOLLOWUP_DESC"

export const TAX_PROCESS_EYEBROW = "TAX_PROCESS_EYEBROW"
export const TAX_PROCESS_TITLE = "TAX_PROCESS_TITLE"
export const TAX_PROCESS_STEP1_TITLE = "TAX_PROCESS_STEP1_TITLE"
export const TAX_PROCESS_STEP1_DESC = "TAX_PROCESS_STEP1_DESC"
export const TAX_PROCESS_STEP2_TITLE = "TAX_PROCESS_STEP2_TITLE"
export const TAX_PROCESS_STEP2_DESC = "TAX_PROCESS_STEP2_DESC"
export const TAX_PROCESS_STEP3_TITLE = "TAX_PROCESS_STEP3_TITLE"
export const TAX_PROCESS_STEP3_DESC = "TAX_PROCESS_STEP3_DESC"
export const TAX_PROCESS_STEP4_TITLE = "TAX_PROCESS_STEP4_TITLE"
export const TAX_PROCESS_STEP4_DESC = "TAX_PROCESS_STEP4_DESC"

export const TAX_CHECKLIST_EYEBROW = "TAX_CHECKLIST_EYEBROW"
export const TAX_CHECKLIST_TITLE = "TAX_CHECKLIST_TITLE"
export const TAX_CHECKLIST_SUBTITLE = "TAX_CHECKLIST_SUBTITLE"
export const TAX_CHECKLIST_GROUP1_TITLE = "TAX_CHECKLIST_GROUP1_TITLE"
export const TAX_CHECKLIST_GROUP1_ITEM1 = "TAX_CHECKLIST_GROUP1_ITEM1"
export const TAX_CHECKLIST_GROUP1_ITEM2 = "TAX_CHECKLIST_GROUP1_ITEM2"
export const TAX_CHECKLIST_GROUP1_ITEM3 = "TAX_CHECKLIST_GROUP1_ITEM3"
export const TAX_CHECKLIST_GROUP2_TITLE = "TAX_CHECKLIST_GROUP2_TITLE"
export const TAX_CHECKLIST_GROUP2_ITEM1 = "TAX_CHECKLIST_GROUP2_ITEM1"
export const TAX_CHECKLIST_GROUP2_ITEM2 = "TAX_CHECKLIST_GROUP2_ITEM2"
export const TAX_CHECKLIST_GROUP2_ITEM3 = "TAX_CHECKLIST_GROUP2_ITEM3"
export const TAX_CHECKLIST_GROUP3_TITLE = "TAX_CHECKLIST_GROUP3_TITLE"
export const TAX_CHECKLIST_GROUP3_ITEM1 = "TAX_CHECKLIST_GROUP3_ITEM1"
export const TAX_CHECKLIST_GROUP3_ITEM2 = "TAX_CHECKLIST_GROUP3_ITEM2"
export const TAX_CHECKLIST_GROUP3_ITEM3 = "TAX_CHECKLIST_GROUP3_ITEM3"

export const TAX_FAQ_EYEBROW = "TAX_FAQ_EYEBROW"
export const TAX_FAQ_TITLE = "TAX_FAQ_TITLE"
export const TAX_FAQ_SUBTITLE = "TAX_FAQ_SUBTITLE"
export const TAX_FAQ_Q1 = "TAX_FAQ_Q1"
export const TAX_FAQ_A1 = "TAX_FAQ_A1"
export const TAX_FAQ_Q2 = "TAX_FAQ_Q2"
export const TAX_FAQ_A2 = "TAX_FAQ_A2"
export const TAX_FAQ_Q3 = "TAX_FAQ_Q3"
export const TAX_FAQ_A3 = "TAX_FAQ_A3"
export const TAX_FAQ_Q4 = "TAX_FAQ_Q4"
export const TAX_FAQ_A4 = "TAX_FAQ_A4"
export const TAX_FAQ_Q5 = "TAX_FAQ_Q5"
export const TAX_FAQ_A5 = "TAX_FAQ_A5"
export const TAX_FAQ_Q6 = "TAX_FAQ_Q6"
export const TAX_FAQ_A6 = "TAX_FAQ_A6"

export const TAX_CTA_TITLE = "TAX_CTA_TITLE"
export const TAX_CTA_SUBTITLE = "TAX_CTA_SUBTITLE"
export const TAX_CTA_BUTTON = "TAX_CTA_BUTTON"

//TRAVEL PAGE
export const TRV_HELMET_TITLE = "TRV_HELMET_TITLE"
export const TRV_HELMET_DESCRIPTION = "TRV_HELMET_DESCRIPTION"

export const TRV_HERO_EYEBROW = "TRV_HERO_EYEBROW"
export const TRV_HERO_TITLE = "TRV_HERO_TITLE"
export const TRV_HERO_TITLE_ACCENT = "TRV_HERO_TITLE_ACCENT"
export const TRV_HERO_SUBTITLE = "TRV_HERO_SUBTITLE"
export const TRV_HERO_CTA_BOOK = "TRV_HERO_CTA_BOOK"
export const TRV_HERO_CTA_CALL = "TRV_HERO_CTA_CALL"
export const TRV_HERO_TRUST_BONDED = "TRV_HERO_TRUST_BONDED"
export const TRV_HERO_TRUST_BILINGUAL = "TRV_HERO_TRUST_BILINGUAL"
export const TRV_HERO_TRUST_GLOBAL = "TRV_HERO_TRUST_GLOBAL"

export const TRV_SERVICES_EYEBROW = "TRV_SERVICES_EYEBROW"
export const TRV_SERVICES_TITLE = "TRV_SERVICES_TITLE"
export const TRV_SERVICES_SUBTITLE = "TRV_SERVICES_SUBTITLE"
export const TRV_SERVICE_FLIGHTS_TITLE = "TRV_SERVICE_FLIGHTS_TITLE"
export const TRV_SERVICE_FLIGHTS_DESC = "TRV_SERVICE_FLIGHTS_DESC"
export const TRV_SERVICE_HOTELS_TITLE = "TRV_SERVICE_HOTELS_TITLE"
export const TRV_SERVICE_HOTELS_DESC = "TRV_SERVICE_HOTELS_DESC"
export const TRV_SERVICE_VISA_TITLE = "TRV_SERVICE_VISA_TITLE"
export const TRV_SERVICE_VISA_DESC = "TRV_SERVICE_VISA_DESC"
export const TRV_SERVICE_INSURANCE_TITLE = "TRV_SERVICE_INSURANCE_TITLE"
export const TRV_SERVICE_INSURANCE_DESC = "TRV_SERVICE_INSURANCE_DESC"
export const TRV_SERVICE_TRANSPORT_TITLE = "TRV_SERVICE_TRANSPORT_TITLE"
export const TRV_SERVICE_TRANSPORT_DESC = "TRV_SERVICE_TRANSPORT_DESC"
export const TRV_SERVICE_PACKAGES_TITLE = "TRV_SERVICE_PACKAGES_TITLE"
export const TRV_SERVICE_PACKAGES_DESC = "TRV_SERVICE_PACKAGES_DESC"

export const TRV_DEST_EYEBROW = "TRV_DEST_EYEBROW"
export const TRV_DEST_TITLE = "TRV_DEST_TITLE"
export const TRV_DEST_SUBTITLE = "TRV_DEST_SUBTITLE"
export const TRV_DEST_CARIBBEAN = "TRV_DEST_CARIBBEAN"
export const TRV_DEST_LATAM = "TRV_DEST_LATAM"
export const TRV_DEST_EUROPE = "TRV_DEST_EUROPE"
export const TRV_DEST_USA = "TRV_DEST_USA"
export const TRV_DEST_CRUISES = "TRV_DEST_CRUISES"
export const TRV_DEST_OTHER = "TRV_DEST_OTHER"

export const TRV_BANNER_EYEBROW = "TRV_BANNER_EYEBROW"
export const TRV_BANNER_TITLE = "TRV_BANNER_TITLE"
export const TRV_BANNER_SUBTITLE = "TRV_BANNER_SUBTITLE"

export const TRV_PROCESS_EYEBROW = "TRV_PROCESS_EYEBROW"
export const TRV_PROCESS_TITLE = "TRV_PROCESS_TITLE"
export const TRV_PROCESS_STEP1_TITLE = "TRV_PROCESS_STEP1_TITLE"
export const TRV_PROCESS_STEP1_DESC = "TRV_PROCESS_STEP1_DESC"
export const TRV_PROCESS_STEP2_TITLE = "TRV_PROCESS_STEP2_TITLE"
export const TRV_PROCESS_STEP2_DESC = "TRV_PROCESS_STEP2_DESC"
export const TRV_PROCESS_STEP3_TITLE = "TRV_PROCESS_STEP3_TITLE"
export const TRV_PROCESS_STEP3_DESC = "TRV_PROCESS_STEP3_DESC"
export const TRV_PROCESS_STEP4_TITLE = "TRV_PROCESS_STEP4_TITLE"
export const TRV_PROCESS_STEP4_DESC = "TRV_PROCESS_STEP4_DESC"

export const TRV_FAQ_EYEBROW = "TRV_FAQ_EYEBROW"
export const TRV_FAQ_TITLE = "TRV_FAQ_TITLE"
export const TRV_FAQ_SUBTITLE = "TRV_FAQ_SUBTITLE"
export const TRV_FAQ_Q1 = "TRV_FAQ_Q1"
export const TRV_FAQ_A1 = "TRV_FAQ_A1"
export const TRV_FAQ_Q2 = "TRV_FAQ_Q2"
export const TRV_FAQ_A2 = "TRV_FAQ_A2"
export const TRV_FAQ_Q3 = "TRV_FAQ_Q3"
export const TRV_FAQ_A3 = "TRV_FAQ_A3"
export const TRV_FAQ_Q4 = "TRV_FAQ_Q4"
export const TRV_FAQ_A4 = "TRV_FAQ_A4"
export const TRV_FAQ_Q5 = "TRV_FAQ_Q5"
export const TRV_FAQ_A5 = "TRV_FAQ_A5"

export const TRV_CTA_TITLE = "TRV_CTA_TITLE"
export const TRV_CTA_SUBTITLE = "TRV_CTA_SUBTITLE"
export const TRV_CTA_BUTTON = "TRV_CTA_BUTTON"

//INSURANCE PAGE
export const INS_HELMET_TITLE = "INS_HELMET_TITLE"
export const INS_HELMET_DESCRIPTION = "INS_HELMET_DESCRIPTION"

export const INS_HERO_EYEBROW = "INS_HERO_EYEBROW"
export const INS_HERO_TITLE = "INS_HERO_TITLE"
export const INS_HERO_TITLE_ACCENT = "INS_HERO_TITLE_ACCENT"
export const INS_HERO_SUBTITLE = "INS_HERO_SUBTITLE"
export const INS_HERO_CTA_BOOK = "INS_HERO_CTA_BOOK"
export const INS_HERO_CTA_CALL = "INS_HERO_CTA_CALL"
export const INS_HERO_TRUST_LICENSED = "INS_HERO_TRUST_LICENSED"
export const INS_HERO_TRUST_BILINGUAL = "INS_HERO_TRUST_BILINGUAL"
export const INS_HERO_TRUST_FREE = "INS_HERO_TRUST_FREE"

export const INS_SERVICES_EYEBROW = "INS_SERVICES_EYEBROW"
export const INS_SERVICES_TITLE = "INS_SERVICES_TITLE"
export const INS_SERVICES_SUBTITLE = "INS_SERVICES_SUBTITLE"
export const INS_SERVICE_HEALTH_TITLE = "INS_SERVICE_HEALTH_TITLE"
export const INS_SERVICE_HEALTH_DESC = "INS_SERVICE_HEALTH_DESC"
export const INS_SERVICE_ACA_TITLE = "INS_SERVICE_ACA_TITLE"
export const INS_SERVICE_ACA_DESC = "INS_SERVICE_ACA_DESC"
export const INS_SERVICE_LIFE_TITLE = "INS_SERVICE_LIFE_TITLE"
export const INS_SERVICE_LIFE_DESC = "INS_SERVICE_LIFE_DESC"
export const INS_SERVICE_MEDICARE_TITLE = "INS_SERVICE_MEDICARE_TITLE"
export const INS_SERVICE_MEDICARE_DESC = "INS_SERVICE_MEDICARE_DESC"
export const INS_SERVICE_DENTAL_TITLE = "INS_SERVICE_DENTAL_TITLE"
export const INS_SERVICE_DENTAL_DESC = "INS_SERVICE_DENTAL_DESC"
export const INS_SERVICE_SUPPLEMENTAL_TITLE = "INS_SERVICE_SUPPLEMENTAL_TITLE"
export const INS_SERVICE_SUPPLEMENTAL_DESC = "INS_SERVICE_SUPPLEMENTAL_DESC"

export const INS_PROCESS_EYEBROW = "INS_PROCESS_EYEBROW"
export const INS_PROCESS_TITLE = "INS_PROCESS_TITLE"
export const INS_PROCESS_STEP1_TITLE = "INS_PROCESS_STEP1_TITLE"
export const INS_PROCESS_STEP1_DESC = "INS_PROCESS_STEP1_DESC"
export const INS_PROCESS_STEP2_TITLE = "INS_PROCESS_STEP2_TITLE"
export const INS_PROCESS_STEP2_DESC = "INS_PROCESS_STEP2_DESC"
export const INS_PROCESS_STEP3_TITLE = "INS_PROCESS_STEP3_TITLE"
export const INS_PROCESS_STEP3_DESC = "INS_PROCESS_STEP3_DESC"
export const INS_PROCESS_STEP4_TITLE = "INS_PROCESS_STEP4_TITLE"
export const INS_PROCESS_STEP4_DESC = "INS_PROCESS_STEP4_DESC"

export const INS_CHECKLIST_EYEBROW = "INS_CHECKLIST_EYEBROW"
export const INS_CHECKLIST_TITLE = "INS_CHECKLIST_TITLE"
export const INS_CHECKLIST_SUBTITLE = "INS_CHECKLIST_SUBTITLE"
export const INS_CHECKLIST_ITEM1 = "INS_CHECKLIST_ITEM1"
export const INS_CHECKLIST_ITEM2 = "INS_CHECKLIST_ITEM2"
export const INS_CHECKLIST_ITEM3 = "INS_CHECKLIST_ITEM3"
export const INS_CHECKLIST_ITEM4 = "INS_CHECKLIST_ITEM4"
export const INS_CHECKLIST_ITEM5 = "INS_CHECKLIST_ITEM5"
export const INS_CHECKLIST_ITEM6 = "INS_CHECKLIST_ITEM6"

export const INS_FAQ_EYEBROW = "INS_FAQ_EYEBROW"
export const INS_FAQ_TITLE = "INS_FAQ_TITLE"
export const INS_FAQ_SUBTITLE = "INS_FAQ_SUBTITLE"
export const INS_FAQ_Q1 = "INS_FAQ_Q1"
export const INS_FAQ_A1 = "INS_FAQ_A1"
export const INS_FAQ_Q2 = "INS_FAQ_Q2"
export const INS_FAQ_A2 = "INS_FAQ_A2"
export const INS_FAQ_Q3 = "INS_FAQ_Q3"
export const INS_FAQ_A3 = "INS_FAQ_A3"
export const INS_FAQ_Q4 = "INS_FAQ_Q4"
export const INS_FAQ_A4 = "INS_FAQ_A4"
export const INS_FAQ_Q5 = "INS_FAQ_Q5"
export const INS_FAQ_A5 = "INS_FAQ_A5"

export const INS_CTA_TITLE = "INS_CTA_TITLE"
export const INS_CTA_SUBTITLE = "INS_CTA_SUBTITLE"
export const INS_CTA_BUTTON = "INS_CTA_BUTTON"

//UNEMPLOYMENT PAGE (new)
export const UNP_HELMET_TITLE = "UNP_HELMET_TITLE"
export const UNP_HELMET_DESCRIPTION = "UNP_HELMET_DESCRIPTION"

export const UNP_HERO_EYEBROW = "UNP_HERO_EYEBROW"
export const UNP_HERO_TITLE = "UNP_HERO_TITLE"
export const UNP_HERO_TITLE_ACCENT = "UNP_HERO_TITLE_ACCENT"
export const UNP_HERO_SUBTITLE = "UNP_HERO_SUBTITLE"
export const UNP_HERO_CTA_BOOK = "UNP_HERO_CTA_BOOK"
export const UNP_HERO_CTA_CALL = "UNP_HERO_CTA_CALL"
export const UNP_HERO_TRUST_BILINGUAL = "UNP_HERO_TRUST_BILINGUAL"
export const UNP_HERO_TRUST_DOCS = "UNP_HERO_TRUST_DOCS"
export const UNP_HERO_TRUST_FAST = "UNP_HERO_TRUST_FAST"

export const UNP_SERVICES_EYEBROW = "UNP_SERVICES_EYEBROW"
export const UNP_SERVICES_TITLE = "UNP_SERVICES_TITLE"
export const UNP_SERVICES_SUBTITLE = "UNP_SERVICES_SUBTITLE"
export const UNP_SERVICE_FILE_TITLE = "UNP_SERVICE_FILE_TITLE"
export const UNP_SERVICE_FILE_DESC = "UNP_SERVICE_FILE_DESC"
export const UNP_SERVICE_APPEAL_TITLE = "UNP_SERVICE_APPEAL_TITLE"
export const UNP_SERVICE_APPEAL_DESC = "UNP_SERVICE_APPEAL_DESC"
export const UNP_SERVICE_WEEKLY_TITLE = "UNP_SERVICE_WEEKLY_TITLE"
export const UNP_SERVICE_WEEKLY_DESC = "UNP_SERVICE_WEEKLY_DESC"
export const UNP_SERVICE_DOCS_TITLE = "UNP_SERVICE_DOCS_TITLE"
export const UNP_SERVICE_DOCS_DESC = "UNP_SERVICE_DOCS_DESC"
export const UNP_SERVICE_TRANSLATE_TITLE = "UNP_SERVICE_TRANSLATE_TITLE"
export const UNP_SERVICE_TRANSLATE_DESC = "UNP_SERVICE_TRANSLATE_DESC"
export const UNP_SERVICE_FOLLOWUP_TITLE = "UNP_SERVICE_FOLLOWUP_TITLE"
export const UNP_SERVICE_FOLLOWUP_DESC = "UNP_SERVICE_FOLLOWUP_DESC"

export const UNP_PROCESS_EYEBROW = "UNP_PROCESS_EYEBROW"
export const UNP_PROCESS_TITLE = "UNP_PROCESS_TITLE"
export const UNP_PROCESS_STEP1_TITLE = "UNP_PROCESS_STEP1_TITLE"
export const UNP_PROCESS_STEP1_DESC = "UNP_PROCESS_STEP1_DESC"
export const UNP_PROCESS_STEP2_TITLE = "UNP_PROCESS_STEP2_TITLE"
export const UNP_PROCESS_STEP2_DESC = "UNP_PROCESS_STEP2_DESC"
export const UNP_PROCESS_STEP3_TITLE = "UNP_PROCESS_STEP3_TITLE"
export const UNP_PROCESS_STEP3_DESC = "UNP_PROCESS_STEP3_DESC"
export const UNP_PROCESS_STEP4_TITLE = "UNP_PROCESS_STEP4_TITLE"
export const UNP_PROCESS_STEP4_DESC = "UNP_PROCESS_STEP4_DESC"

export const UNP_DISCLAIMER_EYEBROW = "UNP_DISCLAIMER_EYEBROW"
export const UNP_DISCLAIMER_TITLE = "UNP_DISCLAIMER_TITLE"
export const UNP_DISCLAIMER_BODY = "UNP_DISCLAIMER_BODY"

export const UNP_FAQ_EYEBROW = "UNP_FAQ_EYEBROW"
export const UNP_FAQ_TITLE = "UNP_FAQ_TITLE"
export const UNP_FAQ_SUBTITLE = "UNP_FAQ_SUBTITLE"
export const UNP_FAQ_Q1 = "UNP_FAQ_Q1"
export const UNP_FAQ_A1 = "UNP_FAQ_A1"
export const UNP_FAQ_Q2 = "UNP_FAQ_Q2"
export const UNP_FAQ_A2 = "UNP_FAQ_A2"
export const UNP_FAQ_Q3 = "UNP_FAQ_Q3"
export const UNP_FAQ_A3 = "UNP_FAQ_A3"
export const UNP_FAQ_Q4 = "UNP_FAQ_Q4"
export const UNP_FAQ_A4 = "UNP_FAQ_A4"
export const UNP_FAQ_Q5 = "UNP_FAQ_Q5"
export const UNP_FAQ_A5 = "UNP_FAQ_A5"

export const UNP_CTA_TITLE = "UNP_CTA_TITLE"
export const UNP_CTA_SUBTITLE = "UNP_CTA_SUBTITLE"
export const UNP_CTA_BUTTON = "UNP_CTA_BUTTON"

//WORKFORCE PAGE
export const WKF_HELMET_TITLE = "WKF_HELMET_TITLE"
export const WKF_HELMET_DESCRIPTION = "WKF_HELMET_DESCRIPTION"

export const WKF_HERO_EYEBROW = "WKF_HERO_EYEBROW"
export const WKF_HERO_TITLE = "WKF_HERO_TITLE"
export const WKF_HERO_TITLE_ACCENT = "WKF_HERO_TITLE_ACCENT"
export const WKF_HERO_SUBTITLE = "WKF_HERO_SUBTITLE"
export const WKF_HERO_CTA_BOOK = "WKF_HERO_CTA_BOOK"
export const WKF_HERO_CTA_CALL = "WKF_HERO_CTA_CALL"
export const WKF_HERO_TRUST_BILINGUAL = "WKF_HERO_TRUST_BILINGUAL"
export const WKF_HERO_TRUST_LOCAL = "WKF_HERO_TRUST_LOCAL"
export const WKF_HERO_TRUST_FAMILIES = "WKF_HERO_TRUST_FAMILIES"

export const WKF_SERVICES_EYEBROW = "WKF_SERVICES_EYEBROW"
export const WKF_SERVICES_TITLE = "WKF_SERVICES_TITLE"
export const WKF_SERVICES_SUBTITLE = "WKF_SERVICES_SUBTITLE"
export const WKF_SERVICE_RESUME_TITLE = "WKF_SERVICE_RESUME_TITLE"
export const WKF_SERVICE_RESUME_DESC = "WKF_SERVICE_RESUME_DESC"
export const WKF_SERVICE_JOBSEARCH_TITLE = "WKF_SERVICE_JOBSEARCH_TITLE"
export const WKF_SERVICE_JOBSEARCH_DESC = "WKF_SERVICE_JOBSEARCH_DESC"
export const WKF_SERVICE_APPLICATIONS_TITLE = "WKF_SERVICE_APPLICATIONS_TITLE"
export const WKF_SERVICE_APPLICATIONS_DESC = "WKF_SERVICE_APPLICATIONS_DESC"
export const WKF_SERVICE_INTERVIEW_TITLE = "WKF_SERVICE_INTERVIEW_TITLE"
export const WKF_SERVICE_INTERVIEW_DESC = "WKF_SERVICE_INTERVIEW_DESC"
export const WKF_SERVICE_TRAINING_TITLE = "WKF_SERVICE_TRAINING_TITLE"
export const WKF_SERVICE_TRAINING_DESC = "WKF_SERVICE_TRAINING_DESC"
export const WKF_SERVICE_REFERRAL_TITLE = "WKF_SERVICE_REFERRAL_TITLE"
export const WKF_SERVICE_REFERRAL_DESC = "WKF_SERVICE_REFERRAL_DESC"

export const WKF_PROCESS_EYEBROW = "WKF_PROCESS_EYEBROW"
export const WKF_PROCESS_TITLE = "WKF_PROCESS_TITLE"
export const WKF_PROCESS_STEP1_TITLE = "WKF_PROCESS_STEP1_TITLE"
export const WKF_PROCESS_STEP1_DESC = "WKF_PROCESS_STEP1_DESC"
export const WKF_PROCESS_STEP2_TITLE = "WKF_PROCESS_STEP2_TITLE"
export const WKF_PROCESS_STEP2_DESC = "WKF_PROCESS_STEP2_DESC"
export const WKF_PROCESS_STEP3_TITLE = "WKF_PROCESS_STEP3_TITLE"
export const WKF_PROCESS_STEP3_DESC = "WKF_PROCESS_STEP3_DESC"
export const WKF_PROCESS_STEP4_TITLE = "WKF_PROCESS_STEP4_TITLE"
export const WKF_PROCESS_STEP4_DESC = "WKF_PROCESS_STEP4_DESC"

export const WKF_FAQ_EYEBROW = "WKF_FAQ_EYEBROW"
export const WKF_FAQ_TITLE = "WKF_FAQ_TITLE"
export const WKF_FAQ_SUBTITLE = "WKF_FAQ_SUBTITLE"
export const WKF_FAQ_Q1 = "WKF_FAQ_Q1"
export const WKF_FAQ_A1 = "WKF_FAQ_A1"
export const WKF_FAQ_Q2 = "WKF_FAQ_Q2"
export const WKF_FAQ_A2 = "WKF_FAQ_A2"
export const WKF_FAQ_Q3 = "WKF_FAQ_Q3"
export const WKF_FAQ_A3 = "WKF_FAQ_A3"
export const WKF_FAQ_Q4 = "WKF_FAQ_Q4"
export const WKF_FAQ_A4 = "WKF_FAQ_A4"
export const WKF_FAQ_Q5 = "WKF_FAQ_Q5"
export const WKF_FAQ_A5 = "WKF_FAQ_A5"

export const WKF_CTA_TITLE = "WKF_CTA_TITLE"
export const WKF_CTA_SUBTITLE = "WKF_CTA_SUBTITLE"
export const WKF_CTA_BUTTON = "WKF_CTA_BUTTON"

export const WKF_DISCLAIMER_EYEBROW = "WKF_DISCLAIMER_EYEBROW"
export const WKF_DISCLAIMER_TITLE = "WKF_DISCLAIMER_TITLE"
export const WKF_DISCLAIMER_BODY = "WKF_DISCLAIMER_BODY"

//NOTARY PAGE
export const NTR_HELMET_TITLE = "NTR_HELMET_TITLE"
export const NTR_HELMET_DESCRIPTION = "NTR_HELMET_DESCRIPTION"

export const NTR_HERO_EYEBROW = "NTR_HERO_EYEBROW"
export const NTR_HERO_TITLE = "NTR_HERO_TITLE"
export const NTR_HERO_TITLE_ACCENT = "NTR_HERO_TITLE_ACCENT"
export const NTR_HERO_SUBTITLE = "NTR_HERO_SUBTITLE"
export const NTR_HERO_CTA_BOOK = "NTR_HERO_CTA_BOOK"
export const NTR_HERO_CTA_CALL = "NTR_HERO_CTA_CALL"
export const NTR_HERO_TRUST_COMMISSIONED = "NTR_HERO_TRUST_COMMISSIONED"
export const NTR_HERO_TRUST_BILINGUAL = "NTR_HERO_TRUST_BILINGUAL"
export const NTR_HERO_TRUST_MOBILE = "NTR_HERO_TRUST_MOBILE"

export const NTR_SERVICES_EYEBROW = "NTR_SERVICES_EYEBROW"
export const NTR_SERVICES_TITLE = "NTR_SERVICES_TITLE"
export const NTR_SERVICES_SUBTITLE = "NTR_SERVICES_SUBTITLE"
export const NTR_SERVICE_ACK_TITLE = "NTR_SERVICE_ACK_TITLE"
export const NTR_SERVICE_ACK_DESC = "NTR_SERVICE_ACK_DESC"
export const NTR_SERVICE_JURAT_TITLE = "NTR_SERVICE_JURAT_TITLE"
export const NTR_SERVICE_JURAT_DESC = "NTR_SERVICE_JURAT_DESC"
export const NTR_SERVICE_COPY_TITLE = "NTR_SERVICE_COPY_TITLE"
export const NTR_SERVICE_COPY_DESC = "NTR_SERVICE_COPY_DESC"
export const NTR_SERVICE_WEDDING_TITLE = "NTR_SERVICE_WEDDING_TITLE"
export const NTR_SERVICE_WEDDING_DESC = "NTR_SERVICE_WEDDING_DESC"
export const NTR_SERVICE_VEHICLE_TITLE = "NTR_SERVICE_VEHICLE_TITLE"
export const NTR_SERVICE_VEHICLE_DESC = "NTR_SERVICE_VEHICLE_DESC"
export const NTR_SERVICE_POA_TITLE = "NTR_SERVICE_POA_TITLE"
export const NTR_SERVICE_POA_DESC = "NTR_SERVICE_POA_DESC"

export const NTR_DOCS_EYEBROW = "NTR_DOCS_EYEBROW"
export const NTR_DOCS_TITLE = "NTR_DOCS_TITLE"
export const NTR_DOCS_SUBTITLE = "NTR_DOCS_SUBTITLE"
export const NTR_DOCS_ITEM1 = "NTR_DOCS_ITEM1"
export const NTR_DOCS_ITEM2 = "NTR_DOCS_ITEM2"
export const NTR_DOCS_ITEM3 = "NTR_DOCS_ITEM3"
export const NTR_DOCS_ITEM4 = "NTR_DOCS_ITEM4"
export const NTR_DOCS_ITEM5 = "NTR_DOCS_ITEM5"
export const NTR_DOCS_ITEM6 = "NTR_DOCS_ITEM6"

export const NTR_PROCESS_EYEBROW = "NTR_PROCESS_EYEBROW"
export const NTR_PROCESS_TITLE = "NTR_PROCESS_TITLE"
export const NTR_PROCESS_STEP1_TITLE = "NTR_PROCESS_STEP1_TITLE"
export const NTR_PROCESS_STEP1_DESC = "NTR_PROCESS_STEP1_DESC"
export const NTR_PROCESS_STEP2_TITLE = "NTR_PROCESS_STEP2_TITLE"
export const NTR_PROCESS_STEP2_DESC = "NTR_PROCESS_STEP2_DESC"
export const NTR_PROCESS_STEP3_TITLE = "NTR_PROCESS_STEP3_TITLE"
export const NTR_PROCESS_STEP3_DESC = "NTR_PROCESS_STEP3_DESC"

export const NTR_FAQ_EYEBROW = "NTR_FAQ_EYEBROW"
export const NTR_FAQ_TITLE = "NTR_FAQ_TITLE"
export const NTR_FAQ_SUBTITLE = "NTR_FAQ_SUBTITLE"
export const NTR_FAQ_Q1 = "NTR_FAQ_Q1"
export const NTR_FAQ_A1 = "NTR_FAQ_A1"
export const NTR_FAQ_Q2 = "NTR_FAQ_Q2"
export const NTR_FAQ_A2 = "NTR_FAQ_A2"
export const NTR_FAQ_Q3 = "NTR_FAQ_Q3"
export const NTR_FAQ_A3 = "NTR_FAQ_A3"
export const NTR_FAQ_Q4 = "NTR_FAQ_Q4"
export const NTR_FAQ_A4 = "NTR_FAQ_A4"
export const NTR_FAQ_Q5 = "NTR_FAQ_Q5"
export const NTR_FAQ_A5 = "NTR_FAQ_A5"

export const NTR_CTA_TITLE = "NTR_CTA_TITLE"
export const NTR_CTA_SUBTITLE = "NTR_CTA_SUBTITLE"
export const NTR_CTA_BUTTON = "NTR_CTA_BUTTON"

export const NTR_DISCLAIMER_EYEBROW = "NTR_DISCLAIMER_EYEBROW"
export const NTR_DISCLAIMER_TITLE = "NTR_DISCLAIMER_TITLE"
export const NTR_DISCLAIMER_BODY = "NTR_DISCLAIMER_BODY"




//CREDIT REAPAIR FAQ
export const CR_FAQ_TITLE = "CR_FAQ_TITLE"
export const CR_FAQ_SUBTITLE = "CR_FAQ_SUBTITLE"
export const CR_FAQ_DESCRIPTION = "CR_FAQ_DESCRIPTION"
export const CR_FAQ_HOW_WORK_QUESTION = "CR_FAQ_HOW_WORK_QUESTION"
export const CR_FAQ_HOW_WORK_ANSWER = "CR_FAQ_HOW_WORK_ANSWER"
export const CR_FAQ_HOW_LONG_TAKE_QUESTION = "CR_FAQ_HOW_LONG_TAKE_QUESTION"
export const CR_FAQ_HOW_LONG_TAKE_ANSWER = "CR_FAQ_HOW_LONG_TAKE_ANSWER"
export const CR_FAQ_CAN_I_DO_IT_QUESTION = "CR_FAQ_CAN_I_DO_IT_QUESTION"
export const CR_FAQ_CAN_I_DO_IT_ANSWER = "CR_FAQ_CAN_I_DO_IT_ANSWER"
export const CR_FAQ_CAN_LINARES_GUARANTEE_RESULTS_QUESTION = "CR_FAQ_CAN_LINARES_GUARANTEE_RESULTS_QUESTION"
export const CR_FAQ_CAN_LINARES_GUARANTEE_RESULTS_ANSWER = "CR_FAQ_CAN_LINARES_GUARANTEE_RESULTS_ANSWER"
export const CR_FAQ_WHY_CREDIT_ITS_IMPORTANT_QUESTION = "CR_FAQ_WHY_CREDIT_ITS_IMPORTANT_QUESTION"
export const CR_FAQ_WHY_CREDIT_ITS_IMPORTANT_ANSWER = "CR_FAQ_WHY_CREDIT_ITS_IMPORTANT_ANSWER"
export const CR_FAQ_WILL_DISPUTING_ERRORS_HURT_CREDIT_SCORE_QUESTION = "CR_FAQ_WILL_DISPUTING_ERRORS_HURT_CREDIT_SCORE_QUESTION"
export const CR_FAQ_WILL_DISPUTING_ERRORS_HURT_CREDIT_SCORE_ANSWER = "CR_FAQ_WILL_DISPUTING_ERRORS_HURT_CREDIT_SCORE_ANSWER"
export const CR_FAQ_WHAT_IS_GOOD_CREDIT_SCORE_QUESTION = "CR_FAQ_WHAT_IS_GOOD_CREDIT_SCORE_QUESTION"
export const CR_FAQ_WHAT_IS_GOOD_CREDIT_SCORE_ANSWER = "CR_FAQ_WHAT_IS_GOOD_CREDIT_SCORE_ANSWER"


//ABOUT US PAGE
export const ABOUT_US_HELMET_TITLE = "ABOUT_US_HELMET_TITLE"
export const ABOUT_US_HELMET_DESCRIPTION = "ABOUT_US_HELMET_DESCRIPTION"
export const ABOUT_US_HEADER_TITLE = "ABOUT_US_HEADER_TITLE"
export const ABOUT_US_INTRO_TITLE = "ABOUT_US_INTRO_TITLE"
export const ABOUT_US_INTRO_SUBTITLE = "ABOUT_US_INTRO_SUBTITLE"
export const ABOUT_US_INTRO_DESCRIPTION = "ABOUT_US_INTRO_DESCRIPTION"
export const ABOUT_US_FIRST_PARAGRAPH = "ABOUT_US_FIRST_PARAGRAPH"
export const ABOUT_US_SECOND_PARAGRAPH = "ABOUT_US_SECOND_PARAGRAPH"
export const ABOUT_US_THIRD_PARAGRAPH = "ABOUT_US_THIRD_PARAGRAPH"

// ABOUT US — redesigned sections
export const ABOUT_HERO_EYEBROW = "ABOUT_HERO_EYEBROW";
export const ABOUT_HERO_TITLE = "ABOUT_HERO_TITLE";
export const ABOUT_HERO_SUBTITLE = "ABOUT_HERO_SUBTITLE";
export const ABOUT_HERO_CTA_PRIMARY = "ABOUT_HERO_CTA_PRIMARY";
export const ABOUT_HERO_CTA_SECONDARY = "ABOUT_HERO_CTA_SECONDARY";

export const ABOUT_STATS_YEARS_VALUE = "ABOUT_STATS_YEARS_VALUE";
export const ABOUT_STATS_YEARS_LABEL = "ABOUT_STATS_YEARS_LABEL";
export const ABOUT_STATS_FAMILIES_VALUE = "ABOUT_STATS_FAMILIES_VALUE";
export const ABOUT_STATS_FAMILIES_LABEL = "ABOUT_STATS_FAMILIES_LABEL";
export const ABOUT_STATS_SERVICES_VALUE = "ABOUT_STATS_SERVICES_VALUE";
export const ABOUT_STATS_SERVICES_LABEL = "ABOUT_STATS_SERVICES_LABEL";
export const ABOUT_STATS_LANGUAGES_VALUE = "ABOUT_STATS_LANGUAGES_VALUE";
export const ABOUT_STATS_LANGUAGES_LABEL = "ABOUT_STATS_LANGUAGES_LABEL";

export const ABOUT_STORY_EYEBROW = "ABOUT_STORY_EYEBROW";
export const ABOUT_STORY_TITLE = "ABOUT_STORY_TITLE";
export const ABOUT_STORY_P1 = "ABOUT_STORY_P1";
export const ABOUT_STORY_P2 = "ABOUT_STORY_P2";
export const ABOUT_STORY_P3 = "ABOUT_STORY_P3";
export const ABOUT_STORY_IMAGE_ALT = "ABOUT_STORY_IMAGE_ALT";

export const ABOUT_VALUES_EYEBROW = "ABOUT_VALUES_EYEBROW";
export const ABOUT_VALUES_TITLE = "ABOUT_VALUES_TITLE";
export const ABOUT_VALUES_SUBTITLE = "ABOUT_VALUES_SUBTITLE";
export const ABOUT_VALUE_TRUST_TITLE = "ABOUT_VALUE_TRUST_TITLE";
export const ABOUT_VALUE_TRUST_DESC = "ABOUT_VALUE_TRUST_DESC";
export const ABOUT_VALUE_BILINGUAL_TITLE = "ABOUT_VALUE_BILINGUAL_TITLE";
export const ABOUT_VALUE_BILINGUAL_DESC = "ABOUT_VALUE_BILINGUAL_DESC";
export const ABOUT_VALUE_FAMILY_TITLE = "ABOUT_VALUE_FAMILY_TITLE";
export const ABOUT_VALUE_FAMILY_DESC = "ABOUT_VALUE_FAMILY_DESC";
export const ABOUT_VALUE_EXPERTISE_TITLE = "ABOUT_VALUE_EXPERTISE_TITLE";
export const ABOUT_VALUE_EXPERTISE_DESC = "ABOUT_VALUE_EXPERTISE_DESC";

export const ABOUT_WHY_EYEBROW = "ABOUT_WHY_EYEBROW";
export const ABOUT_WHY_TITLE = "ABOUT_WHY_TITLE";
export const ABOUT_WHY_ITEM1 = "ABOUT_WHY_ITEM1";
export const ABOUT_WHY_ITEM2 = "ABOUT_WHY_ITEM2";
export const ABOUT_WHY_ITEM3 = "ABOUT_WHY_ITEM3";
export const ABOUT_WHY_ITEM4 = "ABOUT_WHY_ITEM4";
export const ABOUT_WHY_ITEM5 = "ABOUT_WHY_ITEM5";
export const ABOUT_WHY_ITEM6 = "ABOUT_WHY_ITEM6";

export const ABOUT_CTA_TITLE = "ABOUT_CTA_TITLE";
export const ABOUT_CTA_SUBTITLE = "ABOUT_CTA_SUBTITLE";
export const ABOUT_CTA_PRIMARY = "ABOUT_CTA_PRIMARY";
export const ABOUT_CTA_SECONDARY = "ABOUT_CTA_SECONDARY";

// ABOUT PAGE — Founder section
export const ABOUT_FOUNDER_EYEBROW = "ABOUT_FOUNDER_EYEBROW";
export const ABOUT_FOUNDER_NAME = "ABOUT_FOUNDER_NAME";
export const ABOUT_FOUNDER_ROLE = "ABOUT_FOUNDER_ROLE";
export const ABOUT_FOUNDER_BIO = "ABOUT_FOUNDER_BIO";
export const ABOUT_FOUNDER_AFFILIATION = "ABOUT_FOUNDER_AFFILIATION";